module.exports = __webpack_public_path__ + "img/fraiche_et_francaise.ec47e99b.png";